if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        
        // Listener for the "Continue Shopping" button
        this.continueShoppingButton = this.querySelector('[type="submit"][name="add_and_continue"]');
        if (this.continueShoppingButton) {
          this.continueShoppingButton.addEventListener('click', this.onSubmitHandler.bind(this));
        }

        // The original "Add to Cart" button will use the default form submission (and redirect)
        const originalSubmitButton = this.querySelector('[type="submit"][name="add"]');
        if (document.querySelector('cart-drawer') && originalSubmitButton) {
          originalSubmitButton.setAttribute('aria-haspopup', 'dialog');
        }
      }

      // This handler is now ONLY for the "Add to cart and continue shopping" button
      onSubmitHandler(evt) {
        evt.preventDefault();
        const submitButton = evt.currentTarget;
        if (submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();
        submitButton.setAttribute('aria-disabled', true);
        submitButton.classList.add('loading');
        const spinner = submitButton.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);
              this.error = true;
              return;
            }

            this.error = false;
            // --- THIS IS THE FIX ---
            this.updateCartIcon(); // Manually update the cart icon in the header.

            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              quickAddModal.hide(true);
            }
          })
          .catch((e) => console.error(e))
          .finally(() => {
            submitButton.classList.remove('loading');
            if (!this.error) submitButton.removeAttribute('aria-disabled');
            if (spinner) spinner.classList.add('hidden');
          });
      }

      // --- NEW FUNCTION TO MANUALLY REFRESH THE CART ICON ---
      updateCartIcon() {
        // Fetch the header section using Shopify's Section Rendering API
        fetch(`?section_id=header`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const newCartIcon = html.querySelector('#cart-icon-bubble');
            const oldCartIcon = document.getElementById('cart-icon-bubble');
            
            // Replace the old icon's content with the new, updated content
            if (oldCartIcon && newCartIcon) {
              oldCartIcon.innerHTML = newCartIcon.innerHTML;
            }
          })
          .catch((e) => {
            console.error(e);
          });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessageWrapper.querySelector('.product-form__error-message');
        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}